/**
 * @jsxRuntime classic
 * @jsx jsx
 *
 * Hoisted icon render functions (stable references) — required by AFM perf lint
 * rule `@atlassian/perf-linting/no-unstable-inline-props`. The IconButton/Button
 * `icon` / `iconBefore` props must be stable across renders to avoid React tree
 * rerenders for the icon component itself.
 *
 * Keeping every icon used by the Post Stream Review toolbar in a single file
 * means consumers (the action-button cluster) need only one import.
 *
 * Explicit `JSX.Element` return annotations are required by `--isolatedDeclarations`.
 */

import { jsx } from '@compiled/react';

import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import RedoIcon from '@atlaskit/icon/core/redo';
import DislikeIcon from '@atlaskit/icon/core/thumbs-down';
import LikeIcon from '@atlaskit/icon/core/thumbs-up';
import UndoIcon from '@atlaskit/icon/core/undo';

export const renderUndoIcon = (): JSX.Element => <UndoIcon label="" />;
export const renderRedoIcon = (): JSX.Element => <RedoIcon label="" />;
export const renderEyeOpenIcon = (): JSX.Element => <EyeOpenIcon label="" />;
export const renderLikeIcon = (): JSX.Element => <LikeIcon label="" />;
export const renderDislikeIcon = (): JSX.Element => <DislikeIcon label="" />;
export const renderLinkExternalIcon = (): JSX.Element => <LinkExternalIcon label="" />;
export const renderArrowUpIcon = (): JSX.Element => <ArrowUpIcon label="" />;
export const renderArrowDownIcon = (): JSX.Element => <ArrowDownIcon label="" />;
